var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 22",
    fill: "#851A92",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 .773-3.16 20.185c-.063.194-.158.37-.279.514-.12.145-.263.255-.42.324a.943.943 0 0 1-.489.076 1.005 1.005 0 0 1-.47-.185l-4.498-4.365-.052-.049-2.739-2.665-.013-.007-.013-.008.006-.048.019.016.013-.121S16 5.23 16.333 4.833c.332-.397.217-.47.217-.47.025-.477-.6 0-.6 0l-10.725 8.62-4.466-1.904s-.692-.304-.756-.98c-.063-.677.775-1.037.775-1.037L18.535.246S20-.571 20 .773Z"
  })));
};

export default SvgTelegram;